import jwt from 'jsonwebtoken';

export default function jwtChecker(){    
    const sessionJwt = sessionStorage.getItem("token")

    if (sessionJwt !== null){
        try {
            let token = jwt.decode(sessionJwt.slice(7))

            var exp = new Date(1000 * token.exp);
            var sada = new Date();

            if(exp - sada < 0){
                throw new Error()
            }
                
            return sessionJwt
           
            //var decoded = jwt.verify(sessionJwt, process.env.REACT_APP_JWT_SALT)           
            
        } catch(err) {
            sessionStorage.clear()
            return false;
        }
    }
}